import React from 'react';

export const findByType = (children, component) => {
  const result = [];
  /* This is the array of result since Article can have multiple times the same sub-component */
  const type = [component.displayName] || [component.name];
  /* We can store the actual name of the component through the displayName or name property of our sub-component */
  React.Children.forEach(children, (child) => {
    const childType =
      child && child.type && (child.type.displayName || child.type.name);
    if (type.includes(childType)) {
      result.push(child);
    }
  });
  /* Then we go through each React children, if one of matches the name of the sub-component we’re looking for we put it in the result array */
  return result;
};

export const excludeType = (children, component) => {
  const result = [];
  /* This is the array of result since Article can have multiple times the same sub-component */
  const type = [component.displayName] || [component.name];
  /* We can store the actual name of the component through the displayName or name property of our sub-component */
  React.Children.forEach(children, (child) => {
    const childType =
      child && child.type && (child.type.displayName || child.type.name);
    if (!type.includes(childType)) {
      result.push(child);
    }
  });
  /* Then we go through each React children, if one of matches the name of the sub-component we’re looking for we put it in the result array */
  return result;
};

export const isExternalLink = (url) => {
  return /(http(s?)):\/\//i.test(url)
}

export const loadScript = (scriptSrc, onLoadCallback, scriptId) => {
  const s = (document.createElement("script") as any);
  if (scriptId) {
    s.id = `script-${scriptId}`;
  }
  s.type = "text/javascript";
  s.async = true;
  s.src = scriptSrc;
  s.onreadystatechange = element => {
    if (
      element.readyState === "complete" ||
      element.readyState === "loaded"
    ) {
      onLoadCallback();
    }
  };
  s.onload = () => onLoadCallback();
  document.getElementsByTagName("head")[0].appendChild(s);
};

export const loadInlineScript = (scriptContent, type = '', attributes = {}, parentNode) => {
  const s = (document.createElement("script") as any);

  for (const attribute of Object.keys(attributes)) {
    s.dataset[attribute] = attributes[attribute];
  }

  s.type = type;
  s.innerHTML = scriptContent;

  if (parentNode) {
    parentNode.appendChild(s);
  } else {
    document.getElementsByTagName("head")[0].appendChild(s);
  }
};

export const calendlyAnalyticsHandler = (event) => {
  if (event.data.event && event.data.event === 'calendly.event_scheduled') {
    window.analytics?.track('demo_requested');
  }
};
